import { useThemeContext } from "@circle-react/providers/Theme";

import { usePlanHasCustomizeCommunity } from "./useIsCustomizeCommunity";

export const useIsCustomColorTheme = () => {
  const isCustomizeCommunity = usePlanHasCustomizeCommunity();
  const { currentTheme } = useThemeContext();
  return isCustomizeCommunity && currentTheme !== "default";
};
